import { ComponentProps } from "react";

export const NavbarContentLeft = ({ children }: ComponentProps<"div">) => {
  return (
    <div data-testid="navbar-content-left" className="flex flex-row z-20">
      {children}
    </div>
  );
};
